<template>
  <Modal
    :closable="false"
    footer-hide
    v-model="show"
    width="90">
    <div class="query">
      <Form label-position="top" @submit.native.prevent='submit'>
        <FormItem label="キーワード">
          <Input
            v-model="config.keyword"
            placeholder="キーワードで絞り込み">
            <Icon v-show="config.keyword" type="md-close" slot="suffix" @click="config.keyword = null" />
          </Input>
        </FormItem>
        <FormItem label="地域を絞り込む">
          <Select
            v-model="config.prefs"
            multiple
            placeholder="地域を選択"
            style="width: 100%;"
          >
            <Option value="北海道">北海道</Option>
            <Option value="青森県">青森県</Option>
            <Option value="岩手県">岩手県</Option>
            <Option value="宮城県">宮城県</Option>
            <Option value="秋田県">秋田県</Option>
            <Option value="山形県">山形県</Option>
            <Option value="福島県">福島県</Option>
            <Option value="茨城県">茨城県</Option>
            <Option value="栃木県">栃木県</Option>
            <Option value="群馬県">群馬県</Option>
            <Option value="埼玉県">埼玉県</Option>
            <Option value="千葉県">千葉県</Option>
            <Option value="東京都">東京都</Option>
            <Option value="神奈川県">神奈川県</Option>
            <Option value="新潟県">新潟県</Option>
            <Option value="富山県">富山県</Option>
            <Option value="石川県">石川県</Option>
            <Option value="福井県">福井県</Option>
            <Option value="山梨県">山梨県</Option>
            <Option value="長野県">長野県</Option>
            <Option value="岐阜県">岐阜県</Option>
            <Option value="静岡県">静岡県</Option>
            <Option value="愛知県">愛知県</Option>
            <Option value="三重県">三重県</Option>
            <Option value="滋賀県">滋賀県</Option>
            <Option value="京都府">京都府</Option>
            <Option value="大阪府">大阪府</Option>
            <Option value="兵庫県">兵庫県</Option>
            <Option value="奈良県">奈良県</Option>
            <Option value="和歌山県">和歌山県</Option>
            <Option value="鳥取県">鳥取県</Option>
            <Option value="島根県">島根県</Option>
            <Option value="岡山県">岡山県</Option>
            <Option value="広島県">広島県</Option>
            <Option value="山口県">山口県</Option>
            <Option value="徳島県">徳島県</Option>
            <Option value="香川県">香川県</Option>
            <Option value="愛媛県">愛媛県</Option>
            <Option value="高知県">高知県</Option>
            <Option value="福岡県">福岡県</Option>
            <Option value="佐賀県">佐賀県</Option>
            <Option value="長崎県">長崎県</Option>
            <Option value="熊本県">熊本県</Option>
            <Option value="大分県">大分県</Option>
            <Option value="宮崎県">宮崎県</Option>
            <Option value="鹿児島県">鹿児島県</Option>
            <Option value="沖縄県">沖縄県</Option>
          </Select>
        </FormItem>
        <Row>
          <Col span="12">
            <FormItem label="鉄道" style="margin-bottom: 0.5rem;">
              <Checkbox
                :value="config.kinds['鉄道:*']"
                @click.prevent.native="handleCheckKindParent('鉄道:*', ['鉄道:平常通り', '鉄道:遅れ', '鉄道:運転見合わせ', '鉄道:運休'])"
                >すべて</Checkbox>
              （
              <Checkbox
                v-model="config.kinds['鉄道:平常通り']"
                @on-change="handleCheckKindChildren('鉄道:*', ['鉄道:平常通り', '鉄道:遅れ', '鉄道:運転見合わせ', '鉄道:運休'])"
                >平常通り</Checkbox>
              <Checkbox
                v-model="config.kinds['鉄道:遅れ']"
                @on-change="handleCheckKindChildren('鉄道:*', ['鉄道:平常通り', '鉄道:遅れ', '鉄道:運転見合わせ', '鉄道:運休'])"
                >遅れ</Checkbox>
              <Checkbox
                v-model="config.kinds['鉄道:運転見合わせ']"
                @on-change="handleCheckKindChildren('鉄道:*', ['鉄道:平常通り', '鉄道:遅れ', '鉄道:運転見合わせ', '鉄道:運休'])"
                >運転見合わせ</Checkbox>
              <Checkbox
                v-model="config.kinds['鉄道:運休']"
                @on-change="handleCheckKindChildren('鉄道:*', ['鉄道:平常通り', '鉄道:遅れ', '鉄道:運転見合わせ', '鉄道:運休'])"
                >運休</Checkbox>
              ）
            </FormItem>
            <FormItem label="バス" style="margin-bottom: 16px;">
              <Checkbox
                :value="config.kinds['バス:*']"
                @click.prevent.native="handleCheckKindParent('バス:*', ['バス:平常通り', 'バス:遅れ', 'バス:運休'])"
                >すべて</Checkbox>
              （
              <Checkbox
                v-model="config.kinds['バス:平常通り']"
                @on-change="handleCheckKindChildren('バス:*', ['バス:平常通り', 'バス:遅れ', 'バス:運休'])"
                >平常通り</Checkbox>
              <Checkbox
                v-model="config.kinds['バス:遅れ']"
                @on-change="handleCheckKindChildren('バス:*', ['バス:平常通り', 'バス:遅れ', 'バス:運休'])"
                >遅れ</Checkbox>
              <Checkbox
                v-model="config.kinds['バス:運休']"
                @on-change="handleCheckKindChildren('バス:*', ['バス:平常通り', 'バス:遅れ', 'バス:運休'])"
                >運休</Checkbox>
              ）
            </FormItem>
            <FormItem label="空の便" style="margin-bottom: 16px;">
              <Checkbox
                :value="config.kinds['空の便:*']"
                @click.prevent.native="handleCheckKindParent('空の便:*', ['空の便:欠航', '空の便:運休'])"
                >すべて</Checkbox>
              （
              <Checkbox
                v-model="config.kinds['空の便:欠航']"
                @on-change="handleCheckKindChildren('空の便:*', ['空の便:欠航', '空の便:運休'])"
                >欠航</Checkbox>
              <Checkbox
                v-model="config.kinds['空の便:運休']"
                @on-change="handleCheckKindChildren('空の便:*', ['空の便:欠航', '空の便:運休'])"
                >運休</Checkbox>
              ）
            </FormItem>
            <FormItem label="フェリー" style="margin-bottom: 16px;">
              <Checkbox
                :value="config.kinds['フェリー:*']"
                @click.prevent.native="handleCheckKindParent('フェリー:*', ['フェリー:平常通り', 'フェリー:欠航', 'フェリー:運休'])"
                >すべて</Checkbox>
              （
              <Checkbox
                v-model="config.kinds['フェリー:平常通り']"
                @on-change="handleCheckKindChildren('フェリー:*', ['フェリー:平常通り', 'フェリー:欠航', 'フェリー:運休'])"
                >平常通り</Checkbox>
              <Checkbox
                v-model="config.kinds['フェリー:欠航']"
                @on-change="handleCheckKindChildren('フェリー:*', ['フェリー:平常通り', 'フェリー:欠航', 'フェリー:運休'])"
                >欠航</Checkbox>
              <Checkbox
                v-model="config.kinds['フェリー:運休']"
                @on-change="handleCheckKindChildren('フェリー:*', ['フェリー:平常通り', 'フェリー:欠航', 'フェリー:運休'])"
                >運休</Checkbox>
              ）
            </FormItem>
            <FormItem label="道路" style="margin-bottom: 16px;">
              <Checkbox
                :value="config.kinds['道路:*']"
                @click.prevent.native="handleCheckKindParent('道路:*', ['道路:通行止め', '道路:渋滞'])"
                >すべて</Checkbox>
              （
              <Checkbox
                v-model="config.kinds['道路:通行止め']"
                @on-change="handleCheckKindChildren('道路:*', ['道路:通行止め', '道路:渋滞'])"
                >通行止め</Checkbox>
              <Checkbox
                v-model="config.kinds['道路:渋滞']"
                @on-change="handleCheckKindChildren('道路:*', ['道路:通行止め', '道路:渋滞'])"
                >渋滞</Checkbox>
              ）
            </FormItem>
            <FormItem label="停電" style="margin-bottom: 16px;">
              <Checkbox
                :value="config.kinds['停電:*']"
                @click.prevent.native="handleCheckKindParent('停電:*', ['停電:1k', '停電:5k', '停電:10k'])"
                >すべて</Checkbox>
              （
              <Checkbox
                v-model="config.kinds['停電:1k']"
                @on-change="handleCheckKindChildren('停電:*', ['停電:1k', '停電:5k', '停電:10k'])"
                >1,000世帯以上</Checkbox>
              <Checkbox
                v-model="config.kinds['停電:5k']"
                @on-change="handleCheckKindChildren('停電:*', ['停電:1k', '停電:5k', '停電:10k'])"
                >5,000世帯以上</Checkbox>
              <Checkbox
                v-model="config.kinds['停電:10k']"
                @on-change="handleCheckKindChildren('停電:*', ['停電:1k', '停電:5k', '停電:10k'])"
                >10,000世帯以上</Checkbox>
              ）
            </FormItem>
            <FormItem label="メール" style="margin-bottom: 16px;">
              <Checkbox
                :value="config.kinds['メール:*']"
                @click.prevent.native="handleCheckKindParent('メール:*', ['メール:全国', 'メール:局ごと'])"
                >すべて</Checkbox>
              （
              <Checkbox
                v-model="config.kinds['メール:全国']"
                @on-change="handleCheckKindChildren('メール:*', ['メール:全国', 'メール:局ごと'])"
                >ANN</Checkbox>
              <Checkbox
                v-model="config.kinds['メール:局ごと']"
                @on-change="handleCheckKindChildren('メール:*', ['メール:全国', 'メール:局ごと'])"
                >自局</Checkbox>
              ）
            </FormItem>
            <FormItem label="速報" style="margin-bottom: 16px;">
              <Checkbox v-model="config.kinds['超速報']">超速報</Checkbox>
            </FormItem>
          </Col>
          </Col>
          <Col span="12">
            <FormItem label="避難情報" style="margin-bottom: 16px;">
              <Checkbox
                :value="config.kinds['避難勧告・指示情報']"
                @click.prevent.native="handleCheckKindParent('避難勧告・指示情報', ['避難準備', '避難勧告', '避難指示', '災害発生情報', '避難情報:解除'])"
                >すべて</Checkbox>
              （
              <Checkbox
                v-model="config.kinds['避難準備']"
                @on-change="handleCheckKindChildren('避難勧告・指示情報', ['避難準備', '避難勧告', '避難指示', '災害発生情報', '避難情報:解除'])"
                >高齢者等避難</Checkbox>
              <Checkbox
                v-model="config.kinds['避難指示']"
                @on-change="handleCheckKindChildren('避難勧告・指示情報', ['避難準備', '避難勧告', '避難指示', '災害発生情報', '避難情報:解除'])"
                >避難指示</Checkbox>
              <Checkbox
                v-model="config.kinds['災害発生情報']"
                @on-change="handleCheckKindChildren('避難勧告・指示情報', ['避難準備', '避難勧告', '避難指示', '災害発生情報', '避難情報:解除'])"
                >緊急安全確保</Checkbox>
              <Checkbox
                v-model="config.kinds['避難情報:解除']"
                @on-change="handleCheckKindChildren('避難勧告・指示情報', ['避難準備', '避難勧告', '避難指示', '災害発生情報', '避難情報:解除'])"
                >避難解除</Checkbox>
              ）
            </FormItem>
            <FormItem label="避難所情報" style="margin-bottom: 16px;">
              <Checkbox
                :value="config.kinds['避難所情報']"
                @click.prevent.native="handleCheckKindParent('避難所情報', ['避難所情報:開設', '避難所情報:閉鎖'])"
                >すべて</Checkbox>
              （
              <Checkbox
                v-model="config.kinds['避難所情報:開設']"
                @on-change="handleCheckKindChildren('避難所情報', ['避難所開設', '避難所閉鎖'])"
                >避難所開設</Checkbox>
              <Checkbox
                v-model="config.kinds['避難所情報:閉鎖']"
                @on-change="handleCheckKindChildren('避難所情報', ['避難所情報:開設', '避難所情報:閉鎖'])"
                >避難所閉鎖</Checkbox>
              ）
            </FormItem>
            <FormItem label="地震" style="margin-bottom: 16px;">
              <Checkbox
                :value="config.kinds['地震:*']"
                @click.prevent.native="handleCheckKindParent('地震:*', ['地震:7', '地震:6強', '地震:6弱', '地震:5強', '地震:5弱', '地震:4', '地震:3', '地震:震源', '地震:長周期地震動に関する観測情報'])"
                >すべて</Checkbox>
              （
              <Checkbox
                v-model="config.kinds['地震:7']"
                @on-change="handleCheckKindChildren('地震:*', ['地震:7', '地震:6強', '地震:6弱', '地震:5強', '地震:5弱', '地震:4', '地震:3', '地震:震源', '地震:長周期地震動に関する観測情報'])"
                >震度7</Checkbox>
              <Checkbox
                v-model="config.kinds['地震:6強']"
                @on-change="handleCheckKindChildren('地震:*', ['地震:7', '地震:6強', '地震:6弱', '地震:5強', '地震:5弱', '地震:4', '地震:3', '地震:震源', '地震:長周期地震動に関する観測情報'])"
                >震度6強</Checkbox>
              <Checkbox
                v-model="config.kinds['地震:6弱']"
                @on-change="handleCheckKindChildren('地震:*', ['地震:7', '地震:6強', '地震:6弱', '地震:5強', '地震:5弱', '地震:4', '地震:3', '地震:震源', '地震:長周期地震動に関する観測情報'])"
                >震度6弱</Checkbox>
              <Checkbox
                v-model="config.kinds['地震:5強']"
                @on-change="handleCheckKindChildren('地震:*', ['地震:7', '地震:6強', '地震:6弱', '地震:5強', '地震:5弱', '地震:4', '地震:3', '地震:震源', '地震:長周期地震動に関する観測情報'])"
                >震度5強</Checkbox>
              <Checkbox
                v-model="config.kinds['地震:5弱']"
                @on-change="handleCheckKindChildren('地震:*', ['地震:7', '地震:6強', '地震:6弱', '地震:5強', '地震:5弱', '地震:4', '地震:3', '地震:震源', '地震:長周期地震動に関する観測情報'])"
                >震度5弱</Checkbox>
              <Checkbox
                v-model="config.kinds['地震:4']"
                @on-change="handleCheckKindChildren('地震:*', ['地震:7', '地震:6強', '地震:6弱', '地震:5強', '地震:5弱', '地震:4', '地震:3', '地震:震源', '地震:長周期地震動に関する観測情報'])"
                >震度4</Checkbox>
              <Checkbox
                v-model="config.kinds['地震:3']"
                @on-change="handleCheckKindChildren('地震:*', ['地震:7', '地震:6強', '地震:6弱', '地震:5強', '地震:5弱', '地震:4', '地震:3', '地震:震源', '地震:長周期地震動に関する観測情報'])"
                >震度3</Checkbox>
              <Checkbox
                v-model="config.kinds['地震:震源']"
                @on-change="handleCheckKindChildren('地震:*', ['地震:7', '地震:6強', '地震:6弱', '地震:5強', '地震:5弱', '地震:4', '地震:3', '地震:震源', '地震:長周期地震動に関する観測情報'])"
                >震源に関する情報</Checkbox>
              <Checkbox
                v-model="config.kinds['地震:長周期地震動に関する観測情報']"
                @on-change="handleCheckKindChildren('地震:*', ['地震:7', '地震:6強', '地震:6弱', '地震:5強', '地震:5弱', '地震:4', '地震:3', '地震:震源', '地震:長周期地震動に関する観測情報'])"
                >長周期地震動に関する情報</Checkbox>
              ）
            </FormItem>
            <FormItem label="津波警報・注意報" style="margin-bottom: 16px;">
              <Checkbox
                :value="config.kinds['津波警報・注意報:*']"
                @click.prevent.native="handleCheckKindParent('津波警報・注意報:*', ['津波警報・注意報:大津波警報', '津波警報・注意報:津波警報', '津波警報・注意報:津波注意報', '津波情報', '津波情報:満潮情報', '津波警報・注意報:到達予想'])"
                >すべて</Checkbox>
              （
              <Checkbox
                v-model="config.kinds['津波警報・注意報:大津波警報']"
                @on-change="handleCheckKindChildren('津波警報・注意報:*', ['津波警報・注意報:大津波警報', '津波警報・注意報:津波警報', '津波警報・注意報:津波注意報', '津波情報', '津波情報:満潮情報', '津波警報・注意報:到達予想'])"
                >大津波警報</Checkbox>
              <Checkbox
                v-model="config.kinds['津波警報・注意報:津波警報']"
                @on-change="handleCheckKindChildren('津波警報・注意報:*', ['津波警報・注意報:大津波警報', '津波警報・注意報:津波警報', '津波警報・注意報:津波注意報', '津波情報', '津波情報:満潮情報', '津波警報・注意報:到達予想'])"
                >津波警報</Checkbox>
              <Checkbox
                v-model="config.kinds['津波警報・注意報:津波注意報']"
                @on-change="handleCheckKindChildren('津波警報・注意報:*', ['津波警報・注意報:大津波警報', '津波警報・注意報:津波警報', '津波警報・注意報:津波注意報', '津波情報', '津波情報:満潮情報', '津波警報・注意報:到達予想'])"
                >津波注意報</Checkbox>
              <Checkbox
                v-model="config.kinds['津波情報']"
                @on-change="handleCheckKindChildren('津波警報・注意報:*', ['津波警報・注意報:大津波警報', '津波警報・注意報:津波警報', '津波警報・注意報:津波注意報', '津波情報', '津波情報:満潮情報', '津波警報・注意報:到達予想'])"
                >観測情報</Checkbox>
              <Checkbox
                v-model="config.kinds['津波警報・注意報:到達予想']"
                @on-change="handleCheckKindChildren('津波警報・注意報:*', ['津波警報・注意報:大津波警報', '津波警報・注意報:津波警報', '津波警報・注意報:津波注意報', '津波情報', '津波情報:満潮情報', '津波警報・注意報:到達予想'])"
                >到達予想</Checkbox>
              <Checkbox
                v-model="config.kinds['津波情報:満潮情報']"
                @on-change="handleCheckKindChildren('津波警報・注意報:*', ['津波警報・注意報:大津波警報', '津波警報・注意報:津波警報', '津波警報・注意報:津波注意報', '津波情報', '津波情報:満潮情報', '津波警報・注意報:到達予想'])"
                >満潮情報</Checkbox>
              ）
            </FormItem>
            <FormItem label="気象警報・注意報" style="margin-bottom: 16px;">
              <Checkbox
                :value="config.kinds['気象警報・注意報']"
                @click.prevent.native="handleCheckKindParent('気象警報・注意報', ['気象特別警報', '気象危険警報', '気象警報', '気象注意報'])"
                >すべて</Checkbox>
              （
              <Checkbox
                v-model="config.kinds['気象特別警報']"
                @on-change="handleCheckKindChildren('気象警報・注意報', ['気象特別警報', '気象危険警報', '気象警報', '気象注意報'])"
                >特別警報</Checkbox>
              <Checkbox
                class="danger-label"
                v-model="config.kinds['気象危険警報']"
                @on-change="handleCheckKindChildren('気象警報・注意報', ['気象特別警報', '気象危険警報', '気象警報', '気象注意報'])"
                >危険警報</Checkbox>
              <Checkbox
                v-model="config.kinds['気象警報']"
                @on-change="handleCheckKindChildren('気象警報・注意報', ['気象特別警報', '気象危険警報', '気象警報', '気象注意報'])"
                >警報</Checkbox>
              <Checkbox
                v-model="config.kinds['気象注意報']"
                @on-change="handleCheckKindChildren('気象警報・注意報', ['気象特別警報', '気象危険警報', '気象警報', '気象注意報'])"
                >注意報</Checkbox>
              ）
            </FormItem>
            <FormItem label="指定河川洪水予報" style="margin-bottom: 16px;">
              <Checkbox
                :value="config.kinds['指定河川洪水予報']"
                @click.prevent.native="handleCheckKindParent('指定河川洪水予報', ['氾濫特別警報', '氾濫危険警報', '氾濫警報', '氾濫注意報'])"
                >すべて</Checkbox>
              （
              <Checkbox
                class="danger-label"
                v-model="config.kinds['氾濫特別警報']"
                @on-change="handleCheckKindChildren('指定河川洪水予報', ['氾濫特別警報', '氾濫危険警報', '氾濫警報', '氾濫注意報'])"
                >氾濫特別警報</Checkbox>
              <Checkbox
                class="danger-label"
                v-model="config.kinds['氾濫危険警報']"
                @on-change="handleCheckKindChildren('指定河川洪水予報', ['氾濫特別警報', '氾濫危険警報', '氾濫警報', '氾濫注意報'])"
                >氾濫危険警報</Checkbox>
              <Checkbox
                class="danger-label"
                v-model="config.kinds['氾濫警報']"
                @on-change="handleCheckKindChildren('指定河川洪水予報', ['氾濫特別警報', '氾濫危険警報', '氾濫警報', '氾濫注意報'])"
                >氾濫警報</Checkbox>
              <Checkbox
                class="danger-label"
                v-model="config.kinds['氾濫注意報']"
                @on-change="handleCheckKindChildren('指定河川洪水予報', ['氾濫特別警報', '氾濫危険警報', '氾濫警報', '氾濫注意報'])"
                >氾濫注意報</Checkbox>
              ）
            </FormItem>
            <FormItem label="雪" style="margin-bottom: 16px;">
              <Checkbox
                :value="config.kinds['雪:*']"
                @click.prevent.native="handleCheckKindParent('雪:*', ['予想降雪量', '積雪情報'])"
                >すべて</Checkbox>
              （
              <Checkbox
                v-model="config.kinds['予想降雪量']"
                @on-change="handleCheckKindChildren('雪:*', ['予想降雪量', '積雪情報'])"
                >予想降雪量</Checkbox>
              <Checkbox
                v-model="config.kinds['積雪情報']"
                @on-change="handleCheckKindChildren('雪:*', ['予想降雪量', '積雪情報'])"
                >積雪</Checkbox>
              ）
            </FormItem>
            <FormItem label="台風" style="margin-bottom: 16px;">
              <Checkbox
                :value="config.kinds['台風:*']"
                @click.prevent.native="handleCheckKindParent('台風:*', ['台風:位置', '台風:規模'])"
                >すべて</Checkbox>
              （
              <Checkbox
                v-model="config.kinds['台風:位置']"
                @on-change="handleCheckKindChildren('台風:*', ['台風:位置', '台風:規模'])"
                >台風（位置）</Checkbox>
              <Checkbox
                v-model="config.kinds['台風:規模']"
                @on-change="handleCheckKindChildren('台風:*', ['台風:位置', '台風:規模'])"
                >台風（規模）</Checkbox>
              ）
            </FormItem>
            <FormItem label="その他" style="margin-bottom: 16px;">
              <Checkbox class="danger-label" v-model="config.kinds['短時間記録的大雨情報']">記録的短時間大雨</Checkbox>
              <Checkbox class="danger-label" v-model="config.kinds['顕著な大雨']">線状降水帯発生</Checkbox>
              <Checkbox class="danger-label" v-model="config.kinds['顕著な大雪']">短時間大雪</Checkbox>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="24">
            <Button style="float: left" @click="show = false">キャンセル</Button>
            <Button type="primary" style="float: right; margin-left: 1em;" @click="submit">検索</Button>
            <Button type="text" @click="selectAllKind" style="float: right; margin-left: 1em;">すべて選択</Button>
            <Button type="text" @click="clearAllKind" style="float: right; margin-left: 1em;">すべて解除</Button>
          </Col>
        </Row>
      </Form>
    </div>
  </Modal>
</template>

<script>
import _ from 'lodash'
import { mapGetters, mapActions } from 'vuex'

export default {
  data() {
    return {
      show: false,
      config: {
        keyword: null,
        prefs: [],
        kinds: {
          '鉄道:*': true, '鉄道:平常通り': true, '鉄道:運休': true, '鉄道:運転見合わせ': true,'鉄道:遅れ': true,
          'バス:*': true, 'バス:運休': true, 'バス:遅れ': true, 'バス:平常通り': true,
          '空の便:*': true, '空の便:欠航': true, '空の便:運休': true,
          'フェリー:*': true, 'フェリー:欠航': true, 'フェリー:運休': true, 'フェリー:平常通り': true,
          '道路:*': true, '道路:通行止め': true, '道路:渋滞': true,
          '停電:*': true, '停電:10k': true, '停電:5k': true, '停電:1k': true,
          '避難勧告・指示情報': true, '避難準備': true, '避難勧告': true, '避難指示': true, '災害発生情報': true, '避難情報:解除': true,
          '避難所情報': true, '避難所情報:開設': true, '避難所情報:閉鎖': true,
          '地震:*': true, '地震:7': true, '地震:6強': true, '地震:6弱': true, '地震:5強': true, '地震:5弱': true, '地震:4': true, '地震:3': true, '地震:震源': true,
          '地震:長周期地震動に関する観測情報': true,
          '気象警報・注意報': true, '気象特別警報': true, '気象危険警報': true, '気象警報': true, '気象注意報': true,
          '指定河川洪水予報': true, '氾濫特別警報': true, '氾濫危険警報': true, '氾濫警報': true, '氾濫注意報': true,
          '津波警報・注意報:*': true, '津波警報・注意報:大津波警報': true, '津波警報・注意報:津波警報': true, '津波警報・注意報:津波注意報': true, '津波情報': true, '津波情報:満潮情報': true, '津波警報・注意報:到達予想': true,
          '台風:*': true, '台風:位置': true, '台風:規模': true,
          '雪:*': true, '予想降雪量': true, '積雪情報': true,
          '短時間記録的大雨情報': true, '顕著な大雨': true, '顕著な大雪': true,
          'メール:*': true, 'メール:全国': true, 'メール:局ごと': true, '超速報': true,
        },
      },
    }
  },
  watch: {
    target(val) {
      if (val) {
        this.show = true
        this.config.keyword = val.keyword
        this.config.prefs = _.union(this.config.prefs, val.prefs)
        if (val.kinds.length > 0) {
          for (const i in this.config.kinds) {
            this.config.kinds[i] = val.kinds.includes(i)
          }
        }
      } else {
        this.show = false
        this.resetConfig()
      }
    },
    show(val) {
      if (!val) {
        this.unsetTarget()
      }
    },
  },
  computed: {
    ...mapGetters({
      target: 'dashboard/subjectQueryModalTarget'
    }),
  },
  methods: {
    ...mapActions({
      unsetTarget: 'dashboard/unsetSubjectQueryModalTarget',
      storeSubjectQuery: 'dashboard/storeSubjectQuery',
      clearSubjectQuery: 'dashboard/clearSubjectQuery',
      setSubjectQueryModalTarget: 'dashboard/setSubjectQueryModalTarget',
      loadSubject: 'dashboard/loadSubject',
      unloadSubject: 'dashboard/unloadSubject',
    }),
    async submit() {
      this.storeSubjectQuery({
        config: {
          keyword: this.config.keyword,
          prefs: this.config.prefs,
          kinds: Object.values(this.config.kinds).every(v => v) ? [] : Object.keys(this.config.kinds).filter(i => this.config.kinds[i]),
        },
        ...this.$route.params,
      })
      await this.unloadSubject()
      await this.loadSubject(this.$route.params)
      this.show = false
    },
    async selectAllKind() {
      for (const i in this.config.kinds) {
        this.config.kinds[i] = true
      }
    },
    async clearAllKind() {
      for (const i in this.config.kinds) {
        this.config.kinds[i] = false
      }
    },
    async handleCheckKindParent(parent, children) {
      this.config.kinds[parent] = !this.config.kinds[parent]
      for (const i of children) {
        this.config.kinds[i] = this.config.kinds[parent]
      }
    },
    async handleCheckKindChildren(parent, children) {
      if (children.every(i => this.config.kinds[i])) {
        this.config.kinds[parent] = true
      } else {
        this.config.kinds[parent] = false
      }
    },
    async resetConfig() {
      this.config.keyword = null
      this.config.prefs.splice(0, this.config.prefs)
      for (const i in this.config.kinds) {
        this.config.kinds[i] = true
      }
    },
  }
}
</script>

<style scoped>
.danger-label >>> .ivu-checkbox + span {
  color: #d9534f;
}
</style>
